import React from 'react';

export function InputSwitch({name, checked, disabled, onChange, title = '', className = ''}) {

  return <label className={"switch-inline dropdown__link" + (className ? ' ' + className : '')}>
    <input type="checkbox" name={name} checked={checked} className="switch-inline__input" disabled={disabled} onChange={(e) => onChange(name, e.target.checked)} />
    <span className="switch-inline__help">{title}</span>
    <div className="switch-inline__wrapper">
      <span className="switch-inline__slider"></span>
    </div>
  </label>;
}
